import React, { useContext } from "react";

import { useTheme } from "@emotion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@mui/material";

import { ratingButtonsInfo } from "utils/constants";
import { UserContext } from "utils/UserContext";

import PropTypes from "prop-types";

function RatingButtons({ song }) {
  const mainTheme = useTheme();

  const { currentRatings, setCurrentRatings } = useContext(UserContext);

  const selectOption = (songId, theScore, freq) => {
    setCurrentRatings((prev) => ({
      ...prev,
      [songId]: {
        score: theScore,
        frequency: freq,
      },
    }));
    console.log(`Song ID: ${songId}, Frequency: ${freq}`);
  };

  return (
    <>
      {ratingButtonsInfo.map((ratingBtn) => (
        <IconButton
          key={ratingBtn.score}
          sx={{
            borderColor: ratingBtn.color,
            borderRadius: "50%",
            borderWidth: "2px",
            borderStyle: "solid",
            width: "5.5rem",
            height: "5.5rem",
            margin: "0 .70rem",
            overflow: "hidden",
            bgcolor:
              currentRatings[song.id]?.frequency === ratingBtn.value
                ? ratingBtn.color
                : mainTheme.palette.blackPrimary.main,
            "&:hover": {
              bgcolor: ratingBtn.color,
            },
            [mainTheme.breakpoints.down("sm")]: {
              margin: "0",
              width: "4rem",
              height: "4rem",
            },
          }}
          onClick={() => {
            selectOption(song.id, ratingBtn.score, ratingBtn.value);
          }}
        >
          <FontAwesomeIcon
            icon={ratingBtn.icon}
            size="xl"
            style={{ color: "#fff" }}
          />
        </IconButton>
      ))}
    </>
  );
}

RatingButtons.propTypes = {
  song: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

export default RatingButtons;
